import { Button, Dialog, Text } from "@hcsc-fiber/react";
import React, { useContext, useRef, useState, forwardRef, useImperativeHandle } from "react";
import { StateContext } from "../../context/stateContext";
import { translations } from "../../translate";
import styles from "../login/LoginPage.module.scss";
import inputStyles from "./PasskeyNameDialog.module.scss";

interface PasskeyNameDialogProps {
  handleName: (name: string) => void;
  skipAddPassKeyName: () => void;
  closeDialog: () => void;
}

// Define the methods that will be exposed to the parent via ref
export interface PasskeyNameDialogImperativeHandle {
  openDialog: () => void;
  resetDialog: () => void;
}

export const PasskeyNameDialog = forwardRef<PasskeyNameDialogImperativeHandle, PasskeyNameDialogProps>(
  ({ handleName, skipAddPassKeyName, closeDialog }, ref) => {
    const [isOpen, setIsOpen] = useState(true);
    const inputContainer = useRef(null);
    const [nameLength, setNameLength] = useState(0);
    const [name, setName] = useState("");
    const [error, setError] = useState("");
    const { languageCode } = useContext(StateContext);
    const closeModal = () => {
      setIsOpen(false);
      closeDialog();
    };

    useImperativeHandle(ref, () => ({
      openDialog: () => {
        setIsOpen(true);
      },
      resetDialog: () => {
        setName("");
      },
    }));
    const changeCallBack = (e: any) => {
      const value = e.target.value;
      setNameLength(value.length);
      setName(value);

      const passkeyDevicePattern = /^[a-zA-Z0-9!@#$%^&*'’_\- ]+$/;
      if (!passkeyDevicePattern.test(value)) {
        setError(translations.passkeySpecialCharactersAllowed[languageCode]);
      } else if (value.length < 2) {
        setError(translations.minLength[languageCode]);
      } else {
        setError("");
      }
    };
    const skipAddingPasskeyName = () => {
      setIsOpen(false);
      skipAddPassKeyName();
    };

    const handleSubmit = () => {
      if (!error) {
        handleName(name);
        setIsOpen(false);
      }
    };
    return (
      <Dialog isOpen={isOpen} onClose={closeModal}>
        <Dialog.Title>{translations.namePassKey[languageCode]}</Dialog.Title>
        <Dialog.Content>
          <div>
            <Text as="p" margin={[0, 0, 3]}>
              {translations.namePassKeyInfo[languageCode]}
            </Text>
            <form>
              <label className="block mt-4">
                <span className={inputStyles.text3}>{translations.passKeyName[languageCode]}</span>
                <div className={inputStyles.container} ref={inputContainer}>
                  <input
                    minLength={2}
                    maxLength={50}
                    autoFocus={true}
                    className={inputStyles.nameInput}
                    type="text"
                    onChange={changeCallBack}
                    style={{ borderColor: error ? "red" : "initial" }}
                    // onChange={e=>setName(e.target.value)}
                    placeholder={""}
                    defaultValue={name}
                  />
                  <span className={inputStyles.inputCounter}>{nameLength}/50</span>
                  {error && <p style={{ color: "red" }}>{error}</p>}
                </div>
              </label>
            </form>
          </div>
        </Dialog.Content>
        <Dialog.Actions>
          <Button type="submit" disabled={!!error || nameLength < 2} onClick={handleSubmit}>
            {translations.addPassKey[languageCode]}
          </Button>
          <Button onClick={skipAddingPasskeyName} kind="secondary">
            {translations.skipButton[languageCode]}
          </Button>
        </Dialog.Actions>
      </Dialog>
    );
  }
);
